var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "360px",
    height: "48px",
    viewBox: "0 0 360 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Material / Nav Bar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "[Light]-Card-Samples",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Auto-Invoke-Loading-State",
    transform: "translate(0.000000, -882.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Material-/-Nav-Bar-(Dark)",
    transform: "translate(0.000000, 882.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tint-/-Outlook-White",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "base",
    points: "0 0 360 0 360 48 0 48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "List-/-Divider",
    transform: "translate(0.000000, -8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "base",
    x: 0,
    y: 0,
    width: 360,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "List-/-\\uD83D\\uDCE6-/-Divider",
    transform: "translate(0.000000, 7.500000)",
    fill: "#C8C8C8",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "divider",
    x: 0,
    y: 0.5,
    width: 360,
    height: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "recent",
    fill: "#666666",
    fillRule: "evenodd",
    x: 273,
    y: 16,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "home",
    stroke: "#666666",
    strokeWidth: 1,
    cx: 181,
    cy: 24,
    r: 8.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#666666",
    fillRule: "nonzero",
    cx: 181,
    cy: 24,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2719481,15.2473593 C86.2263246,14.695639 86.9999997,15.1409225 86.9999997,16.2463373 L87,30.7555624 C87,31.859003 86.2280325,32.3072478 85.2719485,31.7545403 L72.7227789,24.4999276 C71.7684024,23.9482072 71.7666949,23.0546789 72.7227789,22.5019715 L85.2719481,15.2473593 Z",
    id: "back",
    fill: "#666666",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFooter);
export default __webpack_public_path__ + "static/media/mobile_footer.1fe0929f5dbe8b616864ed00debd5665.svg";
export { ForwardRef as ReactComponent };